import coin from "./coin.png";
import rocket from "./rocket.png";
import thunder from "./thunder.png";

export { coin, rocket, thunder };
